// import React, { useState } from 'react'
// import Container from 'react-bootstrap/Container';
// import { Link, NavLink, useLocation } from "react-router-dom";
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';
// import Dropdown from 'react-bootstrap/Dropdown';
// import "./navbar.css"
// import Logo from "../../assets/images/darkLogo.png"
// import UAE from "../../assets/images/FLAG.png"
// import US from "../../assets/images/en.png"


// const NavbarComponent = ({ toggleLanguage, isRtl }) => {
//     const location = useLocation();

//     const [isDropdownOpen, setIsDropdownOpen] = useState(false);

//     const handleMouseEnter = () => setIsDropdownOpen(true);
//     const handleMouseLeave = () => setIsDropdownOpen(false);

//     const [isOpen, setIsOpen] = useState(false);

//     const toggleMenu = () => setIsOpen(!isOpen);

//     return (
//         <Navbar expand="lg" id="mainNavbar">
//             <Container fluid className="mx-lg-5">
//                 {/* Logo */}
//                 <Navbar.Brand as={Link} to="/" className="logo-container">
//                     <img src={Logo} alt="Logo" />
//                 </Navbar.Brand>

//                 <div className="d-flex align-items-center justify-content-end gap-4">
//                     <button className="d-block d-lg-none language-btn" onClick={toggleLanguage}>
//                         <img src={isRtl ? US : UAE} alt="Language" />
//                     </button>
//                     <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleMenu}>
//                         <span className={`barBox ${isOpen ? "open" : ""}`}>
//                             <span className="bar1"></span>
//                             <span className="bar2"></span>
//                             <span className="bar3"></span>
//                         </span>
//                     </Navbar.Toggle>
//                 </div>

//                 <Navbar.Collapse id="basic-navbar-nav">
//                     <Nav className={`mx-lg-auto ${isRtl ? "rtl-nav" : "ms-auto"}`}>
//                         <Link to="/login" className="NavbarLogin mt-5 mt-lg-0 d-none d-lg-block">
//                             {isRtl ? "تسجيل دخول" : "Login"}
//                         </Link>

//                         {/* Navigation Links */}
//                         <NavLink
//                             to="/"
//                             className={({ isActive }) =>
//                                 `mt-4 mt-lg-0 nav-link ${isActive ? "active" : ""}`
//                             }
//                         >
//                             {isRtl ? "الرئيسية" : "Home"}
//                         </NavLink>

//                         <Dropdown
//                             show={isDropdownOpen}
//                             onMouseEnter={handleMouseEnter}
//                             onMouseLeave={handleMouseLeave}
//                             className="navDrop"
//                         >
//                             <Dropdown.Toggle variant="link" id="dropdown-employee-managing-system">
//                                 {isRtl ? "نظام الموارد البشرية " : "Employee Managing System"}
//                             </Dropdown.Toggle>

//                             <Dropdown.Menu>
//                                 <Dropdown.Item as={Link} to="/facility-management">{isRtl ? 'إدارة ملف المنشأة' : 'Facility file management'}</Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="/facility-management">{isRtl ? 'إدارة بيانات الموظفين' : 'Employee Records'}</Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="/facility-management">{isRtl ? 'سرعة تسديد الرواتب' : 'Speedy payment of salaries'}</Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="/facility-management">{isRtl ? 'الحضـور و الانصـراف' : 'Attendance and departure'}</Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="/facility-management">{isRtl ? 'طلبات الخطابات' : 'Letter requests'}</Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="/facility-management">{isRtl ? 'إجـازات الموظفـين' : 'Employee vacations'}</Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="/facility-management">{isRtl ? 'إنذارات المـوظـفين' : 'Employee warnings'}</Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="/facility-management">{isRtl ? 'نهـاية الخـدمة' : 'End of service'}</Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="/facility-management">{isRtl ? 'ملفـات الموظـفين' : 'Employee files'}</Dropdown.Item>
//                             </Dropdown.Menu>
//                         </Dropdown>

//                         <NavLink
//                             to="/about"
//                             className={({ isActive }) =>
//                                 `mt-4 mt-lg-0 nav-link ${isActive ? "active" : ""}`
//                             }
//                         >
//                             {isRtl ? "نظام الرواتب" : "Payroll System"}
//                         </NavLink>
//                         <NavLink
//                             to="/attendance"
//                             className={({ isActive }) =>
//                                 `mt-4 mt-lg-0 nav-link ${isActive ? "active" : ""}`
//                             }
//                         >
//                             {isRtl ? "الحضور و الانصراف" : "Attendance"}
//                         </NavLink>
//                         <NavLink
//                             to="/hr-servies"
//                             className={({ isActive }) =>
//                                 `mt-4 mt-lg-0 nav-link ${isActive ? "active" : ""}`
//                             }
//                         >
//                             {isRtl ? "العلاقات العامة" : "HR Services"}
//                         </NavLink>
//                         <NavLink
//                             to="/contact"
//                             className={({ isActive }) =>
//                                 `mt-4 mt-lg-0 nav-link ${isActive ? "active" : ""}`
//                             }
//                         >
//                             {isRtl ? "تواصل معنا" : "Contact Us"}
//                         </NavLink>

//                         <Link to="/login" className="NavbarLogin mb-3 d-lg-none">
//                             {isRtl ? "تسجيل دخول" : "Login"}
//                         </Link>
//                     </Nav>
//                 </Navbar.Collapse>

//                 <button className="d-none d-lg-block language-btn" onClick={toggleLanguage}>
//                     <img src={isRtl ? US : UAE} alt="Language" />
//                 </button>
//             </Container>
//         </Navbar>
//     );
// }

// export default NavbarComponent;



// import React, { useState } from 'react';
// import Container from 'react-bootstrap/Container';
// import { Link, NavLink, useLocation } from 'react-router-dom';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';
// import Dropdown from 'react-bootstrap/Dropdown';
// import './navbar.css';
// import Logo from '../../assets/images/darkLogo.png';
// import UAE from '../../assets/images/FLAG.png';
// import US from '../../assets/images/en.png';

// const NavbarComponent = ({ toggleLanguage, isRtl }) => {
//     const location = useLocation();

//     const [isDropdownOpen, setIsDropdownOpen] = useState(false);

//     const handleMouseEnter = () => setIsDropdownOpen(true);
//     const handleMouseLeave = () => setIsDropdownOpen(false);

//     const [isOpen, setIsOpen] = useState(false);

//     const toggleMenu = () => setIsOpen(!isOpen);

//     // Function to check if the link should be active
//     const isActiveLink = (to) => {
//         // If the `to` value is a hash (#), it should not be considered active
//         if (to === '#') return false;
//         return location.pathname === to; // Check if the current pathname matches the `to` value
//     };

//     return (
//         <Navbar expand="lg" id="mainNavbar">
//             <Container fluid className="mx-lg-5">
//                 {/* Logo */}
//                 <Navbar.Brand as={Link} to="/" className="logo-container">
//                     <img src={Logo} alt="Logo" />
//                 </Navbar.Brand>

//                 <div className="d-flex align-items-center justify-content-end gap-4">
//                     <button className="d-block d-lg-none language-btn" onClick={toggleLanguage}>
//                         {/* <img src={isRtl ? US : UAE} alt="Language" /> */}
//                         <span>{isRtl ? 'EN' : 'AR'}</span>
//                     </button>
//                     <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleMenu}>
//                         <span className={`barBox ${isOpen ? 'open' : ''}`}>
//                             <span className="bar1"></span>
//                             <span className="bar2"></span>
//                             <span className="bar3"></span>
//                         </span>
//                     </Navbar.Toggle>
//                 </div>

//                 <Navbar.Collapse id="basic-navbar-nav">
//                     <Nav className={`mx-lg-auto ${isRtl ? 'rtl-nav' : 'ms-auto'}`}>
//                         <Link to="#" className="NavbarLogin mt-5 mt-lg-0 d-none d-lg-block">
//                             {isRtl ? 'تسجيل دخول' : 'Login'}
//                         </Link>

//                         {/* Navigation Links */}
//                         <NavLink
//                             to="/"
//                             className={({ isActive }) =>
//                                 `mt-4 mt-lg-0 nav-link ${isActiveLink('/') ? 'active' : ''}`
//                             }
//                         >
//                             {isRtl ? 'الرئيسية' : 'Home'}
//                         </NavLink>

//                         <Dropdown
//                             show={isDropdownOpen}
//                             onMouseEnter={handleMouseEnter}
//                             onMouseLeave={handleMouseLeave}
//                             className="navDrop"
//                         >
//                             <Dropdown.Toggle variant="link" id="dropdown-employee-managing-system">
//                                 {isRtl ? 'نظام الموارد البشرية ' : 'Employee Managing System'}
//                             </Dropdown.Toggle>

//                             <Dropdown.Menu>
//                                 <Dropdown.Item as={Link} to="#">
//                                     {isRtl ? 'إدارة ملف المنشأة' : 'Facility file management'}
//                                 </Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="#">
//                                     {isRtl ? 'إدارة بيانات الموظفين' : 'Employee Records'}
//                                 </Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="#">
//                                     {isRtl ? 'سرعة تسديد الرواتب' : 'Speedy payment of salaries'}
//                                 </Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="#">
//                                     {isRtl ? 'الحضـور و الانصـراف' : 'Attendance and departure'}
//                                 </Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="#">
//                                     {isRtl ? 'طلبات الخطابات' : 'Letter requests'}
//                                 </Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="#">
//                                     {isRtl ? 'إجـازات الموظفـين' : 'Employee vacations'}
//                                 </Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="#">
//                                     {isRtl ? 'إنذارات المـوظـفين' : 'Employee warnings'}
//                                 </Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="#">
//                                     {isRtl ? 'نهـاية الخـدمة' : 'End of service'}
//                                 </Dropdown.Item>
//                                 <Dropdown.Item as={Link} to="#">
//                                     {isRtl ? 'ملفـات الموظـفين' : 'Employee files'}
//                                 </Dropdown.Item>
//                             </Dropdown.Menu>
//                         </Dropdown>

//                         <NavLink
//                             to="/about"
//                             className={({ isActive }) =>
//                                 `mt-4 mt-lg-0 nav-link ${isActiveLink('/about') ? 'active' : ''}`
//                             }
//                         >
//                             {isRtl ? 'نظام الرواتب' : 'Payroll System'}
//                         </NavLink>
//                         {/* <NavLink
//                             to="#"
//                             className={({ isActive }) =>
//                                 `mt-4 mt-lg-0 nav-link ${isActiveLink('/attendance') ? 'active' : ''}`
//                             }
//                         >
//                             {isRtl ? 'الحضور و الانصراف' : 'Attendance'}
//                         </NavLink> */}
//                         <NavLink
//                             to="/hr-servies"
//                             className={({ isActive }) =>
//                                 `mt-4 mt-lg-0 nav-link ${isActiveLink('/hr-servies') ? 'active' : ''}`
//                             }
//                         >
//                             {isRtl ? 'العلاقات العامة' : 'HR Services'}
//                         </NavLink>
//                         <NavLink
//                             to="#"
//                             className={({ isActive }) =>
//                                 `mt-4 mt-lg-0 nav-link ${isActiveLink('/contact') ? 'active' : ''}`
//                             }
//                         >
//                             {isRtl ? 'تواصل معنا' : 'Contact Us'}
//                         </NavLink>

//                         <Link to="#" className="NavbarLogin mb-3 d-lg-none">
//                             {isRtl ? 'تسجيل دخول' : 'Login'}
//                         </Link>
//                     </Nav>
//                 </Navbar.Collapse>

//                 {/* <button className="d-none d-lg-block language-btn" onClick={toggleLanguage}>
//                     <img src={isRtl ? US : UAE} alt="Language" />
//                 </button> */}
//                 <button className="d-none d-lg-block language-btn" onClick={toggleLanguage}>
//                     <span>{isRtl ? 'EN' : 'AR'}</span>
//                 </button>
//             </Container>
//         </Navbar>
//     );
// };

// export default NavbarComponent;



import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Dropdown from "react-bootstrap/Dropdown";
import "./navbar.css";
import Logo from "../../assets/images/darkLogo.png";



const NavbarComponent = ({ toggleLanguage, isRtl, setCurrentIndex, setPauseTransition }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isNavbarVisible, setIsNavbarVisible] = useState(true);
    const [isMouseMoving, setIsMouseMoving] = useState(false);

    const handleMouseEnter = () => setIsDropdownOpen(true);
    const handleMouseLeave = () => setIsDropdownOpen(false);

    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => setIsOpen(!isOpen);

    const isActiveLink = (to) => {
        if (to === "#") return false;
        return location.pathname === to;
    };

    useEffect(() => {
        let hideTimeout;

        const handleMouseMove = () => {
            setIsMouseMoving(true);
            setIsNavbarVisible(true);

            // Clear any existing timeout
            clearTimeout(hideTimeout);

            // Set a timeout to hide the navbar after 3 seconds of no movement
            hideTimeout = setTimeout(() => {
                if (window.scrollY > 0) {
                    setIsMouseMoving(false);
                    setIsNavbarVisible(false);
                }
            }, 3000);
        };

        const handleScroll = () => {
            if (window.scrollY === 0) {
                // If at the top of the page, always show the navbar
                setIsNavbarVisible(true);
            }
        };

        // Show the navbar on mouse movement
        window.addEventListener("mousemove", handleMouseMove);

        // Detect scrolling to keep the navbar visible when at the top
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("scroll", handleScroll);
            clearTimeout(hideTimeout);
        };
    }, []);




    const scrollToSection = (id) => {
        const scrollToElement = () => {
            const element = document.getElementById(id);
            if (element) element.scrollIntoView({ behavior: 'smooth' });
        };

        if (location.pathname !== '/') {
            navigate('/');
            setTimeout(scrollToElement, 100);
        } else {
            scrollToElement();
        }
    };



    return (
        <Navbar
            expand="lg"
            id="mainNavbar"
            className={`fixed-top ${isNavbarVisible ? "visible" : "hidden"}`}
        >
            <Container fluid className="mx-lg-5">
                <Navbar.Brand as={Link} to="/" className="logo-container">
                    <img src={Logo} alt="Logo" />
                </Navbar.Brand>

                <div className="d-flex align-items-center justify-content-end gap-0">
                    <Link to="#" className="NavbarLogin forEnglish d-block d-lg-none">
                        {isRtl ? "تسجيل دخول" : "Login"}
                    </Link>
                    <button className="d-block d-lg-none language-btn" onClick={toggleLanguage}>
                        <span>{isRtl ? "EN" : "AR"}</span>
                    </button>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleMenu}>
                        <span className={`barBox ${isOpen ? "open" : ""}`}>
                            <span className="bar1"></span>
                            <span className="bar2"></span>
                            <span className="bar3"></span>
                        </span>
                    </Navbar.Toggle>
                </div>

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className={`mx-lg-auto ${isRtl ? "rtl-nav" : "ms-auto"}`}>
                        {/* <Link to="#" className="NavbarLogin forArabic mt-5 mt-lg-0 d-none d-lg-block">
                            {isRtl ? "تسجيل دخول" : "Login"}
                        </Link> */}
                        <NavLink
                            to="/"
                            className={({ isActive }) =>
                                `mt-4 mt-lg-0 nav-link ${isActiveLink("/") ? "active" : ""}`
                            }
                        >
                            {isRtl ? "الرئيسية" : "Home"}
                        </NavLink>
                        <Dropdown
                            show={isDropdownOpen}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            className="navDrop"
                        >
                            <Dropdown.Toggle variant="link" id="dropdown-employee-managing-system">
                                {isRtl ? "نظام الموارد البشرية " : "Employee Managing System"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => {
                                    scrollToSection('regularImageComponent')
                                    setCurrentIndex(0)
                                    setPauseTransition(true)
                                }}>
                                    {isRtl ? 'إدارة ملف المنشأة' : 'Facility file management'}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => {
                                    scrollToSection('regularImageComponent')
                                    setCurrentIndex(1)
                                    setPauseTransition(true)

                                }}>
                                    {isRtl ? 'إدارة بيانات الموظفين' : 'Employee Records'}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => {
                                    scrollToSection('regularImageComponent')
                                    setCurrentIndex(2)
                                    setPauseTransition(true)

                                }}>
                                    {isRtl ? 'سرعة تسديد الرواتب' : 'Speedy payment of salaries'}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => {
                                    scrollToSection('regularImageComponent')
                                    setCurrentIndex(3)
                                    setPauseTransition(true)

                                }}>
                                    {isRtl ? 'الحضـور و الانصـراف' : 'Attendance and departure'}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => {
                                    scrollToSection('regularImageComponent')
                                    setCurrentIndex(4)
                                    setPauseTransition(true)

                                }}>
                                    {isRtl ? 'طلبات الخطابات' : 'Letter requests'}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => {
                                    scrollToSection('regularImageComponent')
                                    setCurrentIndex(5)
                                    setPauseTransition(true)

                                }}>
                                    {isRtl ? 'إجـازات الموظفـين' : 'Employee vacations'}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => {
                                    scrollToSection('regularImageComponent')
                                    setCurrentIndex(6)
                                    setPauseTransition(true)

                                }}>
                                    {isRtl ? 'إنذارات المـوظـفين' : 'Employee warnings'}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => {
                                    scrollToSection('regularImageComponent')
                                    setCurrentIndex(7)
                                    setPauseTransition(true)

                                }}>
                                    {isRtl ? 'نهـاية الخـدمة' : 'End of service'}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => {
                                    scrollToSection('regularImageComponent')
                                    setCurrentIndex(8)
                                    setPauseTransition(true)

                                }}>
                                    {isRtl ? 'ملفـات الموظـفين' : 'Employee files'}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <NavLink
                            to="/about"
                            className={({ isActive }) =>
                                `mt-4 mt-lg-0 nav-link ${isActiveLink("/about") ? "active" : ""}`
                            }
                        >
                            {isRtl ? "نظام الرواتب" : "Payroll System"}
                        </NavLink>
                        <NavLink
                            to="/hr-servies"
                            className={({ isActive }) =>
                                `mt-4 mt-lg-0 nav-link ${isActiveLink("/hr-servies") ? "active" : ""}`
                            }
                        >
                            {isRtl ? "العلاقات العامة" : "HR Services"}
                        </NavLink>
                        <NavLink
                            to="#"
                            className={({ isActive }) =>
                                `mt-4 mt-lg-0 nav-link ${isActiveLink("/contact") ? "active" : ""}`
                            }
                        >
                            {isRtl ? "تواصل معنا" : "Contact Us"}
                        </NavLink>
                        {/* <Link to="#" className="NavbarLogin forEnglish mt-5 mt-lg-0 d-none d-lg-block">
                            {isRtl ? "تسجيل دخول" : "Login"}
                        </Link> */}
                    </Nav>
                </Navbar.Collapse>

                <div className="align-items-center d-none d-lg-flex">
                    <Link to="#" className="NavbarLogin forEnglish mt-5 mt-lg-0">
                        {isRtl ? "تسجيل دخول" : "Login"}
                    </Link>
                    <button className="language-btn" onClick={toggleLanguage}>
                        <span>{isRtl ? "EN" : "AR"}</span>
                    </button>
                </div>

            </Container>
        </Navbar>
    );
};

export default NavbarComponent;
